/**
 * @Author: v_jppjpeng
 * @Date: 2023-08-03 14:33:48
 * @Explain: Dialog - 函数式
 */
import { intlGet } from '@/locales';
import classNames from 'classnames';
import { DialogPlugin } from 'tdesign-react';
// type
import type { DialogOptions } from 'tdesign-react';

interface DialogProps extends DialogOptions {
  iconName?: string;
}
export interface DialogInstance {
  confirmDialog?: {
    hide: () => void;
    update: (config: DialogProps) => void;
  };
  onUpdate: (config: DialogProps) => void;
  onHide: () => void;
  confirm(config: DialogProps): void;
  open(config: DialogProps): void;
}

// 弹窗
class Dialog {
  confirmDialog?: {
    hide: () => void;
    /**
     * 更新弹框内容
     */
    update: (config: DialogProps) => void;
  };
  constructor() {
    this.confirmDialog = {
      hide: () => {},
      update: (config: DialogProps) => {},
    };
  }
  /** 更新确认框 */
  onUpdate(config: DialogProps) {
    this.confirmDialog?.update(config);
  }
  /** 关闭Dialog */
  onHide() {
    this.confirmDialog?.hide();
  }
  /** 普通内容弹窗（body 可传 ReactNode，无确认/取消按钮） */
  open(config: DialogProps) {
    const dialogInstance = DialogPlugin({
      closeBtn: true,
      ...config,
      className: classNames('default-td-dialog', config.className),
      onClose: () => {
        dialogInstance.hide();
        config?.onClose?.();
      },
    });
  }
  /** 确认框 */
  confirm(config: DialogProps) {
    // 获取 TDesign 原生的 Dialog 实例
    const dialogInstance = DialogPlugin.confirm({
      confirmBtn: intlGet('COMMON.DETERMINE'),
      cancelBtn: intlGet('COMMON.CANCEL'),
      onClose: () => {
        this.confirmDialog?.hide();
      },
      ...config,
      className: classNames(
        'default-td-dialog-confirm',
        { 'close-btn': config.closeBtn },
        config.className,
      ),
    });

    // 将原生实例包装成自定义的 confirmDialog，并补充 update 方法逻辑
    this.confirmDialog = {
      hide: () => dialogInstance.hide(),
      update: (newConfig: DialogProps) => {
        // 调用原生 update 方法更新内容，并保持 className 的自定义逻辑
        dialogInstance.update({
          ...newConfig,
          className: classNames(
            'default-td-dialog-confirm',
            { 'close-btn': newConfig.closeBtn },
            newConfig.className,
          ),
        });
      },
    };
  }
}

export default new Dialog() as DialogInstance;
